import {ACTION_TYPES, createAction} from "../actions";
import {call, put, takeEvery} from 'redux-saga/effects'
import {requestLayers} from "../../http/requestLayers";

export function* loadLayerSaga () {
    yield takeEvery(ACTION_TYPES.FETCH_LAYERS, loadLayerData);
}

function* loadLayerData () {
    try {
        const data = yield call(requestLayers);
        yield put(createAction(ACTION_TYPES.FETCH_LAYERS_SUCCESS, {
            data
        }));
    } catch (error) {
        yield put(createAction(ACTION_TYPES.FETCH_LAYERS_ERROR, {error}));
    }
}
